
import { WorldCity } from '../types';

// Expansión de ciudades adicionales para México (de 50 a 150 ciudades)
export const mexicoAdditionalCities: WorldCity[] = [
  { name: 'Tuxtla Gutiérrez', slug: 'tuxtla-gutierrez', population: 598710 },
  { name: 'Heroica Matamoros', slug: 'heroica-matamoros', population: 541979 },
  { name: 'Saltillo', slug: 'saltillo', population: 823128 },
  { name: 'Reynosa', slug: 'reynosa', population: 704767 },
  { name: 'Tonalá', slug: 'tonala', population: 593616 },
  { name: 'Cuernavaca', slug: 'cuernavaca', population: 366321 },
  { name: 'Pachuca', slug: 'pachuca', population: 277375 },
  { name: 'Victoria de Durango', slug: 'victoria-de-durango', population: 688697 },
  { name: 'Ciudad López Mateos', slug: 'ciudad-lopez-mateos', population: 489160 },
  { name: 'San Luis Río Colorado', slug: 'san-luis-rio-colorado', population: 192739 },
  { name: 'Tlalnepantla', slug: 'tlalnepantla', population: 700734 },
  { name: 'Xalapa', slug: 'xalapa', population: 488531 },
  { name: 'Nuevo Laredo', slug: 'nuevo-laredo', population: 425058 },
  { name: 'Celaya', slug: 'celaya', population: 521169 },
  { name: 'Mazatlán', slug: 'mazatlan', population: 438434 },
  { name: 'Ensenada', slug: 'ensenada', population: 486639 },
  { name: 'Coatzacoalcos', slug: 'coatzacoalcos', population: 310698 },
  { name: 'Tlajomulco de Zúñiga', slug: 'tlajomulco-de-zuniga', population: 549442 },
  { name: 'La Paz', slug: 'la-paz-mexico', population: 290286 },
  { name: 'Irapuato', slug: 'irapuato', population: 380941 },
  { name: 'Tapachula', slug: 'tapachula', population: 348156 },
  { name: 'Ciudad Madero', slug: 'ciudad-madero', population: 209175 },
  { name: 'Iguala', slug: 'iguala', population: 140363 },
  { name: 'Ciudad del Carmen', slug: 'ciudad-del-carmen', population: 169466 },
  { name: 'Córdoba', slug: 'cordoba-mexico', population: 196541 },
  { name: 'Tepic', slug: 'tepic', population: 396667 },
  { name: 'Monclova', slug: 'monclova', population: 231107 },
  { name: 'Chilpancingo', slug: 'chilpancingo', population: 273106 },
  { name: 'Ciudad Victoria', slug: 'ciudad-victoria', population: 365089 },
  { name: 'Campeche', slug: 'campeche', population: 259005 },
  { name: 'Colima', slug: 'colima', population: 161175 },
  { name: 'Playa del Carmen', slug: 'playa-del-carmen', population: 149923 },
  { name: 'Minatitlán', slug: 'minatitlan', population: 152983 },
  { name: 'Piedras Negras', slug: 'piedras-negras', population: 163595 },
  { name: 'Poza Rica', slug: 'poza-rica', population: 194050 },
  { name: 'Ciudad Valles', slug: 'ciudad-valles', population: 176025 },
  { name: 'Delicias', slug: 'delicias', population: 148045 },
  { name: 'Los Mochis', slug: 'los-mochis', population: 256613 },
  { name: 'Piedad', slug: 'piedad', population: 103492 },
  { name: 'Ciudad Guzmán', slug: 'ciudad-guzman', population: 108669 },
  { name: 'Cuautla', slug: 'cuautla', population: 194786 },
  { name: 'Orizaba', slug: 'orizaba', population: 120500 },
  { name: 'Nogales', slug: 'nogales', population: 233952 },
  { name: 'Puerto Vallarta', slug: 'puerto-vallarta', population: 291839 },
  { name: 'Fresnillo', slug: 'fresnillo', population: 196899 },
  { name: 'Ciudad Acuña', slug: 'ciudad-acuna', population: 153804 },
  { name: 'Hidalgo del Parral', slug: 'hidalgo-del-parral', population: 109510 },
  { name: 'San Juan del Río', slug: 'san-juan-del-rio', population: 268408 },
  { name: 'Carmen', slug: 'carmen', population: 169466 },
  { name: 'Tehuacán', slug: 'tehuacan', population: 320137 },
  { name: 'Cuauhtémoc', slug: 'cuauhtemoc', population: 168482 },
  { name: 'Navojoa', slug: 'navojoa', population: 157729 },
  { name: 'Zamora', slug: 'zamora', population: 186102 },
  { name: 'Papantla', slug: 'papantla', population: 165595 },
  { name: 'Lerdo', slug: 'lerdo', population: 153863 },
  { name: 'San Cristóbal de las Casas', slug: 'san-cristobal-de-las-casas', population: 215874 },
  { name: 'Chetumal', slug: 'chetumal', population: 169028 },
  { name: 'Comitán', slug: 'comitan', population: 168096 },
  { name: 'Guaymas', slug: 'guaymas', population: 149302 },
  { name: 'Tepatitlán', slug: 'tepatitlan', population: 141906 },
  { name: 'Apodaca', slug: 'apodaca', population: 467157 },
  { name: 'Benito Juárez', slug: 'benito-juarez', population: 743626 },
  { name: 'García', slug: 'garcia', population: 247370 },
  { name: 'San Pedro Garza García', slug: 'san-pedro-garza-garcia', population: 122009 },
  { name: 'General Escobedo', slug: 'general-escobedo', population: 357937 },
  { name: 'Santa Catarina', slug: 'santa-catarina', population: 268955 },
  { name: 'Guadalupe', slug: 'guadalupe-nuevo-leon', population: 678006 },
  { name: 'San Nicolás de los Garza', slug: 'san-nicolas-de-los-garza', population: 443273 },
  { name: 'El Marqués', slug: 'el-marques', population: 138336 },
  { name: 'Corregidora', slug: 'corregidora', population: 104218 },
  { name: 'Huimilpan', slug: 'huimilpan', population: 35554 },
  { name: 'Pedro Escobedo', slug: 'pedro-escobedo', population: 21822 },
  { name: 'Peñamiller', slug: 'penamiller', population: 56553 },
  { name: 'Tolimán', slug: 'toliman', population: 25021 },
  { name: 'Cadereyta de Montes', slug: 'cadereyta-de-montes', population: 69549 },
  { name: 'Amealco', slug: 'amealco', population: 64667 },
  { name: 'Pinal de Amoles', slug: 'pinal-de-amoles', population: 25325 },
  { name: 'San Joaquín', slug: 'san-joaquin', population: 7634 },
  { name: 'Arroyo Seco', slug: 'arroyo-seco', population: 12493 },
  { name: 'Jalpan de Serra', slug: 'jalpan-de-serra', population: 23246 },
  { name: 'Landa de Matamoros', slug: 'landa-de-matamoros', population: 18905 },
  { name: 'Ixtapan de la Sal', slug: 'ixtapan-de-la-sal', population: 35401 },
  { name: 'Valle de Bravo', slug: 'valle-de-bravo', population: 68669 },
  { name: 'Zacualpan', slug: 'zacualpan', population: 4761 },
  { name: 'Ixtapan del Oro', slug: 'ixtapan-del-oro', population: 6629 },
  { name: 'Santo Tomás', slug: 'santo-tomas', population: 8715 },
  { name: 'Otzoloapan', slug: 'otzoloapan', population: 4864 },
  { name: 'Luvianos', slug: 'luvianos', population: 23673 },
  { name: 'Tejupilco', slug: 'tejupilco', population: 71077 },
  { name: 'Amatepec', slug: 'amatepec', population: 28907 },
  { name: 'Tlatlaya', slug: 'tlatlaya', population: 31981 },
  { name: 'San Simón de Guerrero', slug: 'san-simon-de-guerrero', population: 5040 },
  { name: 'Temascaltepec', slug: 'temascaltepec', population: 32870 },
  { name: 'Almoloya de Alquisiras', slug: 'almoloya-de-alquisiras', population: 14910 },
  { name: 'Sultepec', slug: 'sultepec', population: 25809 },
  { name: 'Texcaltitlán', slug: 'texcaltitlan', population: 19503 },
  { name: 'Coatepec Harinas', slug: 'coatepec-harinas', population: 36174 },
  { name: 'Villa Guerrero', slug: 'villa-guerrero', population: 59855 },
  { name: 'Ixtlahuaca', slug: 'ixtlahuaca', population: 141482 },
  { name: 'San Felipe del Progreso', slug: 'san-felipe-del-progreso', population: 270706 },
  { name: 'Villa de Allende', slug: 'villa-de-allende', population: 49597 },
  { name: 'San José del Rincón', slug: 'san-jose-del-rincon', population: 101853 },
  { name: 'Donato Guerra', slug: 'donato-guerra', population: 33455 },
  { name: 'Villa Victoria', slug: 'villa-victoria', population: 115490 }
];
